class keyFigure {
  constructor() {

    if (window.innerWidth <= 768) {
      return;
    }

    const elements = document.querySelectorAll('.lc-keyfigure__content.lc-keyfigure__content--top');
    if (elements.length === 0) return;

    let maxHeight = 0;

    // Find the maximum height
    elements.forEach((el) => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Apply the maximum height
    elements.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  }
}

export default keyFigure;
